<template>
  <el-config-provider :locale="curLocale">
    <div id="app">
      <router-view />
    </div>
  </el-config-provider>
</template>
<script>
import { computed  } from "vue";
import { ElConfigProvider } from 'element-plus'
// import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import eleLocale from './locales/ele'
import { useStore } from "vuex"
export default {
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  data() {
    const store = useStore()
    return {
      // locale: zhCn,
      curLocale: computed(() => eleLocale[store.state.lang])
    }
  },
  created() {
  },
  mounted() {
    // if (!window.localStorage.getItem('token')) {
    //   this.$router.push({ path: '/login' })
    // }
  }
}
</script>
<style lang="scss">
@import "./icons/iconfont.css";
@import "@/styles/base.scss";
@import "@/styles/element-ui.scss";

.tox-tinymce-aux, .tox-tinymce-inline {
  z-index: 709826033 !important;
}

</style>
